import BasePage from "../BasePage";
import LoginForm from "./LoginForm";
import Logo from "assets/ib-logo.png";
import React from "react";

const LoginPage = (props) => {
  return (
    <BasePage>
      <div className="row justify-content-center">
        <div className="col-12 d-flex justify-content-center">
          <img src={Logo} alt="logo" className={"logo-login col-auto"} />
        </div>
        <div className="col-12 mw-480">
          <div className="card">
            <div className="card-body">
              <div className="card-title text-uppercase text-center">
                Bem-vindo!
                <br />
                Faça seu Login
              </div>
              <div className="mini-separator mb-2" />
              <LoginForm {...props} />
            </div>
          </div>
        </div>
      </div>
    </BasePage>
  );
};

export default LoginPage;
